import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import { AssumptionAdminOverride } from 'Overrides/AssumptionAdminOverride';
import { displayErrorMessage, displaySuccess } from 'Helpers/FacetNotificationManager';
import AssumptionAdminLayout from './AssumptionAdminLayout';

const styles = () => ({
  root: {},
});

const Template = ({
  className,
  classes,
  collection,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <MetaCollectionFormInline
        collection={collection}
        metaOverrideSet={AssumptionAdminOverride}
        FormProps={{
          layout: AssumptionAdminLayout,
          onSubmit: () => displaySuccess('Saved assumptions'),
          onFailure: (err) => displayErrorMessage('Failed to save', err),
          confirmSubmitMessage: 'Are you sure you want to update global defaults?',
        }}
      />
    </Box>
  );
};

Template.defaultProps = {
  className: '',
};

Template.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  collection: PropTypes.object.isRequired,
};

export default withStyles(styles)(Template);
